var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCard
    ? _c("div", { attrs: { id: "VisitorCalenderCard" } }, [
        _c("div", { attrs: { id: "CalendarCard" } }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(
              (_vm.visitorEvents || []).slice(-5),
              function (event, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    on: {
                      click: function ($event) {
                        return _vm.getDetail()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(event.summary) +
                        " - " +
                        _vm._s(_vm.formatDate(event.start.dateTime)) +
                        "\n            "
                    ),
                  ]
                )
              }
            ),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headtitle" }, [
      _c("span", { staticClass: "text" }, [_vm._v("Takvim")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }